import script from "./MedicalAlertForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedicalAlertForm.vue?vue&type=script&setup=true&lang=ts"

import "./MedicalAlertForm.vue?vue&type=style&index=0&id=a5e8004e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5e8004e"]])

export default __exports__